import React from 'react';
import { X } from 'lucide-react';
import './CaseModals.css';

interface UploadDocumentModalProps {
  isOpen: boolean;
  selectedFile: File | null;
  isUploading: boolean;
  uploadProgress: string;
  onClose: () => void;
  onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onUpload: () => void;
  formatFileSize: (bytes: number) => string;
}

const UploadDocumentModal: React.FC<UploadDocumentModalProps> = ({
  isOpen,
  selectedFile,
  isUploading,
  uploadProgress,
  onClose,
  onFileSelect,
  onUpload,
  formatFileSize,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop" onClick={onClose}></div>
      <div className="upload-modal">
        <div className="modal-header">
          <h2>Upload Document</h2>
          <button onClick={onClose} className="close-modal-btn">
            <X size={24} />
          </button>
        </div>

        <div className="modal-content">
          <div className="file-select-container">
            <input
              type="file"
              onChange={onFileSelect}
              className="file-input-hidden"
              id="file-upload-input"
            />
            <label htmlFor="file-upload-input" className="file-select-btn">
              Choose File
            </label>
            {selectedFile && (
              <span className="selected-file-display">
                {selectedFile.name}
                <span className="file-size-inline"> ({formatFileSize(selectedFile.size)})</span>
              </span>
            )}
          </div>
          {uploadProgress && (
            <div className="upload-progress">
              <p>{uploadProgress}</p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="cancel-btn" disabled={isUploading}>
            Cancel
          </button>
          <button
            onClick={onUpload}
            disabled={!selectedFile || isUploading}
            className="upload-btn"
          >
            {isUploading ? 'Uploading...' : 'Upload'}
          </button>
        </div>
      </div>
    </>
  );
};

export default UploadDocumentModal;

